<template>
  <div class="flex flex-col lg:flex-row pr-4 dark:bg-gray-700 min-h-screen">

    <!-- Sidebar -->
    <transition name="sidebar-slide">
      <div v-show="sidebarOpen"
        class="w-full lg:w-60 relative flex flex-col space-y-4 bg-blue-100 border dark:bg-gray-800 dark:border-gray-900 shadow-md pb-4">
        <!-- Close button -->
        <!-- <button
          @click="sidebarOpen = false"
          class="absolute top-1 right-1 bg-white dark:bg-gray-700 rounded-full shadow p-1 border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-600 transition"
        >
          <svg class="w-3 h-3 text-blue-600 hover:text-red-600 dark:text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button> -->
        <!-- Top buttons block -->
        <div class="p-3 pt-2 mt-1 space-y-2">
          <button @click="goToAddJob" class="w-full py-1.5 font-bold text-sm rounded-full bg-gradient-to-b from-gray-300 to-gray-400 text-gray-800 border border-gray-400 shadow-sm
                  dark:from-gray-700 dark:to-gray-800 dark:text-gray-200 dark:border-gray-600 hover:from-gray-400 hover:to-gray-500
                  dark:hover:from-gray-600 dark:hover:to-gray-700 transition">
            Add Job
          </button>

          <button @click="handleEditJob" class="w-full py-1.5 font-bold text-sm rounded-full bg-gradient-to-b from-gray-300 to-gray-400 text-gray-800 border border-gray-400 shadow-sm
                  dark:from-gray-700 dark:to-gray-800 dark:text-gray-200 dark:border-gray-600  hover:from-gray-400 hover:to-gray-500
                  dark:hover:from-gray-600 dark:hover:to-gray-700 transition">
            Edit Job
          </button>

          <button @click="handleDeleteJob" class="w-full py-1.5 font-bold text-sm rounded-full bg-gradient-to-b from-gray-300 to-gray-400 text-gray-800 border border-gray-400 shadow-sm
                  dark:from-gray-700 dark:to-gray-800 dark:text-gray-200 dark:border-gray-600  hover:from-gray-400 hover:to-gray-500
                  dark:hover:from-gray-600 dark:hover:to-gray-700 transition">
            Delete Job
          </button>
        </div>
        <!-- Bottom filter + calendar block -->
        <div class="pl-3 pr-3">
          <!-- Filter block -->
          <div class="space-y-2 pb-2">
            <div>
              <label class="block mb-1 text-xs text-gray-700 dark:text-gray-200 font-bold">Start Date</label>
              <input v-model="startDate" type="date"
                class="w-full p-1.5 border border-gray-400 border-2 rounded text-xs dark:bg-gray-400 dark:border-gray-400" />
            </div>
            <div>
              <label class="block mb-1 text-xs text-gray-700 dark:text-gray-200 font-bold">End Date</label>
              <input type="date" v-model="endDate"
                class="w-full p-1.5 border border-gray-400 border-2 rounded text-xs dark:bg-gray-400 dark:border-gray-400" />
            </div>

            <div class="flex justify-between">
              <button @click="handleFilterClick"
                class="px-3 py-1 bg-blue-500 text-white text-xs border border-blue-500 border-2 rounded-full hover:bg-blue-600 hover:border-blue-600 hover:text-white">Filter</button>
              <button @click="handleWeekView"
                class="px-3 py-1 bg-blue-500 text-white text-xs border border-blue-500 border-2 rounded-full hover:bg-blue-600 hover:border-blue-600 hover:text-white">
                Week View
              </button>
            </div>
          </div>
          <div id="datepicker-inline" style="height: 260px;" class="text-center w-full max-w-[300px] mb-8 !m-0 !p-0">
          </div>
          <div class="w-full max-w-sm mx-auto bg-white dark:bg-gray-900 shadow-lg rounded-lg p-2 mt-0">
            <h3 class="text-xs font-semibold text-gray-700 dark:text-gray-200">Logged Today: {{ (parseFloat(time.time1
              || timestats.time1).toFixed(1)) }}</h3>
            <h3 class="text-xs font-semibold text-gray-700 dark:text-gray-200 mt-2">Total Today: {{
              (parseFloat(time.time2 || timestats.time2).toFixed(1)) }}</h3>
          </div>

          <!-- Current Pay Period Stats -->
          <div class="w-full max-w-sm mx-auto bg-white dark:bg-gray-900 shadow-lg rounded-lg p-3 mt-3"
            v-if="!userroles.includes(80)">
            <h3 class="text-xs font-bold text-gray-800 dark:text-gray-100 text-center mb-2">
              Current Pay Period ({{ stats.daysremain }} days left)
            </h3>
            <div class="space-y-1 text-xs font-medium text-gray-700 dark:text-gray-200">
              <!-- Logged -->
              <div class="flex justify-between border-b border-gray-300 dark:border-gray-700 pb-1">
                <span>Logged:</span>
                <span :class="stats.period > 80 ? 'text-red-500 font-bold' : ''">
                  {{ parseFloat(stats.period || 0).toFixed(1) }}
                </span>
              </div>
              <!-- This Week -->
              <div class="flex justify-between border-b border-gray-300 dark:border-gray-700 pb-1">
                <span>This Week:</span>
                <span :class="stats.currentweektime > 80 ? 'text-red-500 font-bold' : ''">
                  {{ parseFloat(stats.currentweektime || 0).toFixed(1) }}
                </span>
              </div>
              <!-- End of Day Target -->
              <div class="flex justify-between border-b border-gray-300 dark:border-gray-700 pb-1">
                <span>End of Day Target:</span>
                <span>{{ parseFloat(stats.target || 0).toFixed(1) }}</span>
              </div>
              <!-- AIM -->
              <div class="flex justify-between border-b border-gray-300 dark:border-gray-700 pb-1">
                <span :class="stats.aimPct > 20 ? 'text-red-500 font-bold' : ''">
                  AIM {{ stats.aimPct }}% :
                </span>
                <span>{{ parseFloat(stats.aimTime || 0).toFixed(1) }}</span>
              </div>
              <!-- Lunch/Personal -->
              <div class="flex justify-between">
                <span>Lunch/Personal:</span>
                <span>{{ parseFloat(stats.breaktime || 0).toFixed(1) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- Closed icon button -->
    <!-- <button
      v-if="!sidebarOpen"
      @click="sidebarOpen = true"
      class="fixed left-2 top-20 z-50 bg-blue-100 rounded-full shadow p-1 border border-blue-500 hover:bg-gray-100 dark:hover:bg-gray-600 transition"
    >
      <svg class="w-6 h-6 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
        <path fill-rule="evenodd" d="M10.271 5.575C8.967 4.501 7 5.43 7 7.12v9.762c0 1.69 1.967 2.618 3.271 1.544l5.927-4.881a2 2 0 0 0 0-3.088l-5.927-4.88Z" clip-rule="evenodd"/>
      </svg>
    </button> -->
    <!-- Main content -->
    <div class="flex-1 mt-1 lg:mt-0 lg:ml-4 pt-1">
      <div class="relative mb-2 mt-1">
        <div class="flex justify-between items-start mb-2 space-x-4 text-xs font-medium">
          <div v-if="leaveToday.length" class="w-1/2 rounded-md">
            <div v-for="(i, idx) in leaveToday" :key="'today-' + idx" class="flex items-start mb-1 text-red-600">
              <div>{{ i.pasttoday }} {{ i.daypart }} {{ i.employee }} {{ i.leavetype }} {{ i.range }}</div>
              <div v-if="i.public_note" class="relative group"
                @mouseenter="hoveredLeaveIndex = idx; hoveredLeaveType = 'today'"
                @mouseleave="hoveredLeaveIndex = null">
                <svg class="w-5 h-5 text-blue-500 ml-2 cursor-pointer" xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd"
                    d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9.408-5.5a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM10 10a1 1 0 1 0 0 2h1v3h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-4a1 1 0 0 0-1-1h-2Z"
                    clip-rule="evenodd" />
                </svg>
                <div v-if="hoveredLeaveIndex === idx && hoveredLeaveType === 'today'"
                  class="absolute left-7 top-0 z-10 bg-gray-800 text-white text-xs border border-gray-800 rounded-md shadow-md px-2 py-1 w-48 whitespace-pre-line">
                  {{ i.public_note }}
                </div>
              </div>
            </div>
          </div>
          <div v-else></div>
          <div v-if="leaveFuture.length" class="w-1/2 rounded-md text-right">
            <div v-for="(i, idx) in leaveFuture" :key="'future-' + idx"
              class="flex justify-end items-start mb-1 text-yellow-600">
              <div>{{ i.range }} {{ i.pasttoday }} {{ i.daypart }} {{ i.employee }} {{ i.leavetype }}</div>
              <div v-if="i.public_note" class="relative group"
                @mouseenter="hoveredLeaveIndex = idx; hoveredLeaveType = 'future'"
                @mouseleave="hoveredLeaveIndex = null">
                <svg class="w-5 h-5 text-blue-500 dark:text-blue ml-2 cursor-pointer" xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd"
                    d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9.408-5.5a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM10 10a1 1 0 1 0 0 2h1v3h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-4a1 1 0 0 0-1-1h-2Z"
                    clip-rule="evenodd" />
                </svg>
                <div v-if="hoveredLeaveIndex === idx && hoveredLeaveType === 'future'"
                  class="absolute right-6 top-4 z-10 bg-gray-800 text-white text-xs border border-gray-800 rounded-md shadow-md px-2 py-1 w-48 whitespace-pre-line text-left">
                  {{ i.public_note }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Internal (AIM IT Services) broadcasts get their own banner -->
        <InternalBroadcastBanner :broadcasts="activeBroadcasts" />

        <!-- Active client broadcasts — shown above Action Items so techs see known issues -->
        <div v-if="clientBroadcasts.length" @click="showBroadcastsDropdown = !showBroadcastsDropdown" :class="[
          'rounded-full border-2 px-4 py-1 text-sm font-bold text-center cursor-pointer select-none transition-all duration-300 flex items-center justify-center space-x-2 mb-2',
          'bg-red-100 text-red-700 border-red-400 dark:bg-red-400/20 dark:border-red-600 dark:text-red-300 bg-opacity-40'
        ]">
          <span class="underline">ACTIVE BROADCASTS: {{ clientBroadcasts.length }}</span>
          <svg :class="['transition-transform', showBroadcastsDropdown ? 'rotate-180' : 'rotate-0']"
            xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>

        <transition name="fade">
          <div v-if="showBroadcastsDropdown && clientBroadcasts.length"
            class="relative mt-2 mb-2 w-full bg-red-100 border border-red-400 bg-opacity-40 rounded-xl p-4 shadow-lg dark:bg-red-400/20 dark:border-red-600">
            <ul class="space-y-2 max-h-[250px] overflow-y-auto text-sm">
              <li v-for="b in clientBroadcasts" :key="b.id" class="flex items-center gap-2 min-w-0 text-gray-800 dark:text-gray-100">
                <span :class="['flex-shrink-0 inline-block rounded-full px-2 py-0.5 text-xs font-bold text-white', b.type === 'outage' ? 'bg-red-500' : 'bg-blue-600']">
                  {{ b.type === 'outage' ? 'Outage' : 'Info' }}
                </span>
                <span v-if="b.clients && b.clients.length"
                  class="flex-shrink-0 inline-block rounded-full px-2 py-0.5 text-xs font-semibold bg-gray-200 text-gray-700 dark:bg-gray-600 dark:text-gray-100">
                  {{ b.clients.join(', ') }}
                </span>
                <a v-if="b.ticket_id" :href="`/ticket/${b.ticket_id}`" target="_blank"
                  class="flex-shrink-0 text-blue-600 hover:underline dark:text-blue-300 text-xs">#{{ b.ticket_id }}</a>
                <strong class="flex-shrink-0 text-gray-900 dark:text-gray-100">{{ b.subject }}</strong>
                <span v-if="b.message" class="flex-1 min-w-0 truncate text-gray-600 dark:text-gray-300">— {{ b.message }}</span>
              </li>
            </ul>
          </div>
        </transition>

        <div @click="showActionItemsDropdown = !showActionItemsDropdown" :class="[
          'rounded-full border-2 px-4 py-1 text-sm font-bold text-center cursor-pointer select-none transition-all duration-300 flex items-center justify-center space-x-2',
          actionItemCount > 0
            ? 'bg-red-100 text-red-700 border-red-400 dark:bg-red-400/20 dark:border-red-600 dark:text-red-300 bg-opacity-40'
            : 'bg-green-400 text-green-800 border-green-600 dark:bg-gray-400/20 dark:border-gray-800 dark:text-gray-300 bg-opacity-20'
        ]">
          <template v-if="actionItemCount > 0">
            <span v-if="newActionItemCount > 0"
              class="bg-red-500 text-white text-xs font-semibold px-2 py-0.5 rounded-full"> {{ newActionItemCount }} New
            </span>
            <span class="underline">ACTION ITEMS: {{ actionItemCount }}</span>
            <svg :class="['transition-transform', showActionItemsDropdown ? 'rotate-180' : 'rotate-0']"
              xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </template>
          <template v-else>
            <span class="underline">ACTION ITEMS: 0</span>
          </template>
        </div>

        <transition name="fade">
          <div v-if="showActionItemsDropdown && actionItemCount > 0"
            class="relative mt-2 w-full bg-red-100 border border-red-400 bg-opacity-40 rounded-xl p-4 shadow-lg">
            <ul class="space-y-2 max-h-[250px] overflow-y-auto text-sm">
              <li v-for="(item, index) in actionItems" :key="index" class="flex items-start justify-left">
                <div v-if="item.type === 'ticket'" class="ml-2 text-green-600 cursor-pointer hover:text-green-800">
                  <button @click.stop="acknowledgeTicket(item.data.id)" title="Acknowledge Ticket">
                    <svg class="w-5 h-5 mr-2 text-green-600 hover:text-green-800" xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor" viewBox="0 0 24 24">
                      <path fill-rule="evenodd"
                        d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l4-4Z"
                        clip-rule="evenodd" />
                    </svg>
                  </button>
                  <button @click="startQuickJob(item.data.id)" title="Quick add a Job">
                    <svg class="h-5 w-5 mr-2 text-red-500" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10" />
                      <polygon points="10 8 16 12 10 16 10 8" />
                    </svg>
                  </button>
                  <button @click="gotoAddJob(item.data.id)" title="Add Job">
                    <svg class="h-5 w-5 mr-2 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M17 14v6m-3-3h6M6 10h2a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2zm10 0h2a2 2 0 002-2V6a2 2 0 00-2-2h-2a2 2 0 00-2 2v2a2 2 0 002 2zM6 20h2a2 2 0 002-2v-2a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2z" />
                    </svg>
                  </button>
                </div>

                <div v-else class="ml-2 text-yellow-600">
                  <svg class="w-5 h-5 mr-2 text-yellow-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                    <path fill-rule="evenodd"
                      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0V8Zm-1 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z"
                      clip-rule="evenodd" />
                  </svg>
                </div>

                <div>
                  <template v-if="item.type === 'ticket'">
                    <strong>Acknowledge Ticket from {{ item.data.client?.shortname || item.data.client?.companyname
                    }}:</strong>
                    <a :href="`/ticket/${item.data.id}`" class="text-blue-700 hover:underline" target="_blank"
                      :title="item.data.description ? item.data.description.substring(0, 100) : 'No description available'">
                      #{{ item.data.id }}</a>
                    - {{ truncate(item.data.description, descLimit) }}
                  </template>
                  <template v-else-if="item.type === 'myRequest' && !userroles.includes(80)">
                    Time Off Request Pending:
                    <span class="text-blue-700">{{ item.data.leaveType?.name }} from {{ item.data.start_date }} to {{
                      item.data.end_date }}</span>
                  </template>
                  <template v-else-if="item.type === 'managerRequest' && !userroles.includes(80)">
                    Time Off Request Needs Your Approval:
                    <span class="text-blue-700">{{ item.data.user_profile?.firstname }}’s request for {{
                      item.data.start_date }} - {{ item.data.end_date }}</span>
                  </template>
                </div>
              </li>
            </ul>
          </div>
        </transition>
      </div>
      <div class="flex justify-center space-x-2 my-2" v-if="!userroles.includes(80)">
        <button v-if="showMiscShortcut" @click="addJobShortcut('misc')" class="px-3 py-1 text-xs font-bold rounded-full bg-gradient-to-b from-gray-300 to-gray-400 text-gray-800 border border-gray-400 shadow-sm
                dark:from-gray-700 dark:to-gray-800 dark:text-gray-200 dark:border-gray-600 hover:from-gray-400 hover:to-gray-500
                dark:hover:from-gray-600 dark:hover:to-gray-700 transition">
          Aim/Misc
        </button>

        <button v-if="showTriageShortcut" @click="addJobShortcut('triage')" class="px-3 py-1 text-xs font-bold rounded-full bg-gradient-to-b from-gray-300 to-gray-400 text-gray-800 border border-gray-400 shadow-sm
                dark:from-gray-700 dark:to-gray-800 dark:text-gray-200 dark:border-gray-600 hover:from-gray-400 hover:to-gray-500
                dark:hover:from-gray-600 dark:hover:to-gray-700 transition">
          Triage
        </button>

        <button v-if="showLunchShortcut" @click="addJobShortcut('lunch')" class="px-3 py-1 text-xs font-bold rounded-full bg-gradient-to-b from-gray-300 to-gray-400 text-gray-800 border border-gray-400 shadow-sm
                dark:from-gray-700 dark:to-gray-800 dark:text-gray-200 dark:border-gray-600 hover:from-gray-400 hover:to-gray-500
                dark:hover:from-gray-600 dark:hover:to-gray-700 transition">
          Lunch/Personal
        </button>
      </div>
      <div
        class="border border-blue-500 dark:border-gray-800 border-2 rounded-t-2xl rounded-b-xl h-[calc(100vh-100px)] 2xl:h-[calc(100vh-250px)] flex flex-col">
        <div
          class="bg-blue-500 dark:bg-gray-800 text-white flex px-4 py-2 rounded-t-xl font-bold text-sm items-center flex-none">
          <div class="w-full lg:w-12 ml-8">Action</div>
          <div class="w-full lg:w-72 cursor-pointer text-center" @click="setSort('client')"
            :class="{ 'sort-asc': sortColumn === 'client' && sortDirection === 'asc', 'sort-desc': sortColumn === 'client' && sortDirection === 'desc' }">
            Client
          </div>
          <div class="w-full lg:w-40 cursor-pointer text-center" @click="setSort('jobType')"
            :class="{ 'sort-asc': sortColumn === 'jobType' && sortDirection === 'asc', 'sort-desc': sortColumn === 'jobType' && sortDirection === 'desc' }">
            Type
          </div>
          <div class="w-full lg:flex-[2] cursor-pointer text-center" @click="setSort('description')"
            :class="{ 'sort-asc': sortColumn === 'description' && sortDirection === 'asc', 'sort-desc': sortColumn === 'description' && sortDirection === 'desc' }">
            Description
          </div>
          <div class="w-16 text-right mr-10 cursor-pointer" @click="setSort('time')"
            :class="{ 'sort-asc': sortColumn === 'time' && sortDirection === 'asc', 'sort-desc': sortColumn === 'time' && sortDirection === 'desc' }">
            Time
          </div>
        </div>
        <div class="overflow-y-auto flex-1" ref="jobList">
          <template v-for="job in jobs" :key="job.id">
            <div :ref="'jobCard_' + job.id" :class="[
              'flex rounded-2xl shadow-lg overflow-hidden m-4 border-2',
              job.jobtype_id === 10 ? 'bg-gray-200 dark:bg-gray-600' : 'bg-white dark:bg-gray-800',
              selectedJobIdForAction === job.id
                ? 'border-blue-500 ring-2 ring-blue-500 dark:border-blue-400 dark:ring-blue-400'
                : 'border-gray-100 dark:border-gray-800'
            ]" @click="selectedJobIdForAction = job.id">
              <div :class="[
                'w-8 flex items-center justify-center cursor-pointer p-1',
                job.jobtype_id === 10 ? 'bg-gray-300 dark:bg-gray-400' : (job.starttime !== '0000-00-00 00:00:00' ? 'bg-red-500' : 'bg-green-500')
              ]" @click.stop="job.starttime === '0000-00-00 00:00:00' ? startJob(job) : stopJob(job)">
                <template v-if="job.jobtype_id !== 10">
                  <svg v-if="job.starttime == '0000-00-00 00:00:00'" class="h-6 w-6 text-white" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <polygon points="10 8 16 12 10 16 10 8" />
                  </svg>
                  <svg v-else class="w-6 h-6 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M10 9v6m4-6v6m7-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                  </svg>
                </template>
              </div>

              <div class="flex flex-col lg:flex-row items-start w-full p-2 space-y-2 lg:space-y-0 lg:space-x-4">
                <!-- Action buttons -->
                <div
                  class="w-full lg:w-6 space-y-2 text-sm font-bold text-gray-800 dark:text-gray-200 lg:flex-shrink-0">
                  <!-- Add Note -->
                  <button @click.stop="toggleEditJob(job)" class="flex items-center space-x-1 hover:text-blue-500"
                    title="Edit Job Details">
                    <svg class="h-5 w-5 text-blue-500" width="24" height="24" viewBox="0 0 24 24" stroke-width="2"
                      stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" />
                      <line x1="13" y1="20" x2="20" y2="13" />
                      <path d="M13 20v-6a1 1 0 0 1 1 -1h6v-7a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7" />
                    </svg>
                  </button>

                  <!-- Send Email -->
                  <button class="flex items-center space-x-1 hover:text-blue-500" @click.stop="openEmailModal(job)"
                    title="Send Email">
                    <svg class="w-5 h-5 text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24"
                      height="24" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                        d="m3.5 5.5 7.893 6.036a1 1 0 0 0 1.214 0L20.5 5.5M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Z" />
                    </svg>
                  </button>

                  <!-- Add Docs -->
                  <button class="flex items-center space-x-1 hover:text-blue-500" @click.stop="triggerdoc(job)"
                    v-if="job.ticket" title="Add Docs">
                    <svg class="w-5 h-5 text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24"
                      height="24" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M7 8v8a5 5 0 1 0 10 0V6.5a3.5 3.5 0 1 0-7 0V15a2 2 0 0 0 4 0V8" />
                    </svg>
                  </button>
                  <input type="file" :ref="'fileInput_' + job.id" class="hidden" multiple
                    @change="handleFilesSelected(job)" />

                  <!-- Complete -->
                  <button class="flex items-center space-x-1 hover:text-blue-500"
                    v-if="job.ticket && job.ticket.completed == '0000-00-00 00:00:00'"
                    @click="openSetCompleteTicketModal(job, job.ticket)" title="Close Ticket">
                    <svg class="h-5 w-5 text-blue-500" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                      <polyline points="22 4 12 14.01 9 11.01" />
                    </svg>
                  </button>
                  <button @click.stop="openJobHistory(job)" class="flex items-center space-x-1 hover:text-blue-500"
                    title="Job History">
                    <svg class="h-5 w-5 text-blue-500" fill="none" stroke="currentColor" stroke-width="2"
                      viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" />
                    </svg>
                  </button>
                </div>

                <!-- Client info and type -->
                <div class="w-full lg:w-72 text-xs font-bold">
                  <div>
                    <p class="dark:text-white text-left lg:text-center">
                      <span>
                        <a :href="`https://atms.aimitservices.com/clients.php?do=filter&selectedClientID=${job.client?.id}`"
                          class="text-blue-600 hover:underline" target="_blank">
                          {{ job.client?.companyname || '' }}
                        </a>
                      </span><br><br>
                      <a :href="`https://atms.aimitservices.com/addressBook.php?search=${getRequesterName(job)}&fname=1&lname=1`"
                        class="text-blue-600 hover:underline" target="_blank">
                        {{ getRequesterName(job) }}
                      </a><br>
                      <template v-for="(ph, phi) in getRequesterPhones(job)" :key="phi">
                        <a :href="`tel:${ph.number}${ph.ext ? ',' + ph.ext : ''}`"
                          class="text-blue-600 hover:underline">
                          {{ formatPhone(ph.number) }}
                          <span v-if="ph.ext"> x{{ ph.ext }}</span>
                        </a>
                        <span v-if="ph.label"> ({{ ph.label }})</span><br>
                      </template>
                      <a :href="`mailto:${getRequesterEmail(job)}`" class="text-blue-600 hover:underline"
                        target="_blank">
                        {{ getRequesterEmail(job) }}
                      </a>
                    </p>
                  </div>
                </div>
                <div class="hidden">
                  bg-pink-300 bg-green-400 bg-red-200 bg-blue-400 bg-yellow-400
                  bg-blue-200 bg-yellow-300 bg-gray-300 bg-violet-400 bg-purple-300
                </div>
                <div
                  :class="['w-full lg:w-40 xl:w-40 2xl:w-40 space-y-1 text-xs lg:ml-2 self-stretch flex flex-col justify-start items-center py-2 bg-opacity-40', job.background_class]">
                  <div class="rounded p-2 text-center font-bold">
                    <select v-model="job.jobtype_id" :disabled="job.jobtype_id === 10" @change="changeJobType(job)"
                      class="text-xs py-1 h-7 dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100 mt-1 block w-full rounded-md border-gray-300 shadow-sm">
                      <option v-for="jobType in jobTypes" :key="jobType.id" :value="jobType.id">{{ jobType.name }}
                      </option>
                    </select>
                  </div>
                  <span class="mt-2 text-center dark:text-white font-medium">{{ job.updatedts }}</span>
                </div>

                <!-- Description -->
                <div
                  class="w-full lg:flex-[2] dark:bg-gray-900 lg:ml-2 rounded p-2 text-sm h-full flex flex-col space-y-1 overflow-visible">
                  <div class="flex items-start space-x-2" v-if="job.ticket">
                    <!-- Ticket Link -->
                    <button @click.stop="goToViewTicket(job.ticket.id)"
                      class="flex items-center space-x-1 text-blue-500 hover:underline focus:outline-none">
                      <span class="text-blue-500 text-sm">
                        #{{ job.ticket.id }}
                      </span>
                    </button>
                    <span class="text-gray-600 dark:text-gray-300 text-sm">
                      - {{ job.ticket.description?.substring(0, 60) || '' }}
                    </span>
                  </div>
                  <!-- Toast UI Viewer if used -->
                  <div :id="`viewer-${job.id}`"></div>
                </div>

                <!-- Time -->
                <div class="ml-2 text-sm font-bold text-gray-700 dark:text-gray-100 w-20 text-center">
                  <div v-if="job.starttime !== '0000-00-00 00:00:00'">
                    {{ runningTimes[job.id] ? runningTimes[job.id].toFixed(2) : (parseFloat(job.totaltime ||
                      0).toFixed(2)) }}
                  </div>
                  <div v-else>
                    {{ (parseFloat(job.totaltime || 0).toFixed(2)) }}
                  </div>
                </div>
              </div>
            </div>
            <!-- Transition area to show selected files -->
            <transition name="fade">
              <div v-if="activeJobIdForDocs === job.id"
                class="w-240 bg-gray-200 dark:bg-gray-600 rounded p-4 ml-4 mr-4 shadow-sm">
                <h3 class="font-bold text-sm mb-2 text-gray-700 dark:text-gray-200">Selected Files</h3>
                <div class="flex justify-center">
                  <button @click="triggerFileInput(job)"
                    class="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600">
                    Select Documents
                  </button>
                </div> <br>
                <div class="dark:text-white text-center">OR</div><br>
                <div ref="pasteDropZone"
                  class="border-2 border-dashed border-blue-400 rounded-md p-12 mb-3 bg-white/40 dark:bg-gray-700/40 text-center cursor-text"
                  contenteditable="true" @paste.prevent="handlePaste($event, job)"
                  @dragover.prevent="onDropZoneDragOver" @drop.prevent="handleDrop($event, job)" tabindex="0">
                  <div class="text-xs text-gray-600 dark:text-gray-200">
                    Paste images here (Ctrl/Cmd + V) or drop files…
                  </div>
                </div>
                <ul class="space-y-1 text-gray-600 dark:text-gray-300">
                  <li v-for="(file, index) in selectedFiles" :key="index"
                    class="flex items-center justify-between rounded-md bg-white/60 dark:bg-gray-700 px-3 py-1 text-sm">
                    <span class="truncate mr-3">{{ file.name }}</span>
                    <button type="button" @click="removeSelectedFile(index)" :title="`Remove ${file.name}`"
                      aria-label="Remove file"
                      class="ml-2 shrink-0 text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300 font-bold text-lg leading-none">
                      &times;
                    </button>
                  </li>
                </ul>
                <div class="mt-3 flex justify-end space-x-2">
                  <button @click="uploadFiles(job)"
                    class="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600">Upload</button>
                  <button @click="cancelFiles"
                    class="bg-gray-400 text-white px-4 py-2 rounded-md hover:bg-gray-500">Cancel</button>
                </div>
              </div>
            </transition>
            <transition name="quicknote-transition" @after-enter="onEditorTransitionEnter(job)">
              <div v-if="editJob.id === job.id" :key="job.id + '-quicknote'"
                class="w-240 bg-white dark:bg-gray-600 rounded p-4 ml-4 mr-4 shadow-sm">
                <div class="grid grid-cols-4 gap-4 mb-2">
                  <div class="col-span-2 sm:col-span-1">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Time</label>
                    <div class="relative mt-1">
                      <input type="text" v-model="editJob.time" @input="editJob.timeManuallyChanged = true"
                        class="block w-full pr-8 rounded-md border-gray-300 shadow-sm dark:bg-gray-500 dark:border-gray-900 dark:text-gray-100" />
                      <div class="absolute right-1 top-1/2 transform -translate-y-1/2 flex flex-col space-y-0.5">
                        <button type="button" @click="adjustTime('time', 0.05)"
                          class="text-gray-500 hover:text-blue-500 dark:text-gray-300 dark:hover:text-blue-400">
                          ▲
                        </button>
                        <button type="button" @click="adjustTime('time', -0.05)"
                          class="text-gray-500 hover:text-blue-500 dark:text-gray-300 dark:hover:text-blue-400">
                          ▼
                        </button>
                      </div>
                    </div>
                    <div v-if="job.starttime !== '0000-00-00 00:00:00' && editJob.id === job.id"
                      class="font-bold text-red-500 mt-1">
                      + {{ timeSinceStarted[job.id] ? timeSinceStarted[job.id].toFixed(2) : '0.00' }}
                    </div>
                  </div>
                  <div class="col-span-2 sm:col-span-1">
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">IA</label>
                    <div class="relative mt-1">
                      <input type="text" v-model="editJob.ia"
                        class="block w-full pr-8 rounded-md border-gray-300 shadow-sm dark:bg-gray-500 dark:border-gray-900 dark:text-gray-100" />
                      <div class="absolute right-1 top-1/2 transform -translate-y-1/2 flex flex-col space-y-0.5">
                        <button type="button" @click="adjustTime('ia', 0.05)"
                          class="text-gray-500 hover:text-blue-500 dark:text-gray-300 dark:hover:text-blue-400">
                          ▲
                        </button>
                        <button type="button" @click="adjustTime('ia', -0.05)"
                          class="text-gray-500 hover:text-blue-500 dark:text-gray-300 dark:hover:text-blue-400">
                          ▼
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="flex items-center space-x-2 mt-5 col-span-2 sm:col-span-1 min-w-0">
                    <label class="text-sm font-medium text-gray-700 dark:text-gray-100">Publish</label>
                    <input type="checkbox" v-model="editJob.publish"
                      class="rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                  </div>
                  <div class="col-span-2 sm:col-span-1 md:col-span-1 md:justify-self-end
                    mt-5 flex flex-wrap items-center gap-2 whitespace-nowrap">
                    <button @click="saveEditJob(job)" :disabled="savingJob"
                      class="bg-yellow-500 text-white px-4 py-2 rounded-md hover:bg-yellow-400 disabled:opacity-50">
                      Save
                    </button>

                    <button @click="saveEditJob(job, true)" :disabled="savingJob"
                      class="bg-yellow-500 text-white rounded-md px-4 py-2 hover:bg-yellow-400 disabled:opacity-50">
                      Save & Close
                    </button>
                    <button @click="cancelEditJob"
                      class="bg-gray-400 px-4 py-2 text-white rounded-md hover:bg-gray-600 dark:bg-red-700 dark:hover:bg-red-500">Close</button>
                  </div>
                </div>
                <!-- <textarea v-model="editJob.description" rows="4" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-500 dark:border-gray-900 dark:text-gray-100"></textarea> -->
                <div :ref="'editor_' + job.id"></div>
                <div class="mt-4 flex justify-end space-x-2">
                  <button @click="saveEditJob(job)" :disabled="savingJob"
                    class="bg-yellow-500 text-white px-4 py-2 rounded-md hover:bg-yellow-400 disabled:opacity-50">
                    Save
                  </button>

                  <button @click="saveEditJob(job, true)" :disabled="savingJob"
                    class="bg-yellow-500 text-white px-4 py-2 rounded-md hover:bg-yellow-400 disabled:opacity-50">
                    Save & Close
                  </button>
                  <button @click="cancelEditJob"
                    class="bg-gray-400 text-white px-4 py-2 rounded-md hover:bg-gray-600 dark:bg-red-700 dark:hover:bg-red-500">Close</button>
                </div>
              </div>
            </transition>
          </template>
        </div>
      </div>
    </div>
    <SendEmailModal :isVisible="showEmailModal" :jobId="selectedJobId" :requesterName="selectedRequesterName"
      :requesterEmail="selectedRequesterEmail" :ccEmails="ccEmails"
      :ticketShortDescription="selectedTicketShortDescription" @close="showEmailModal = false"
      @send="handleEmailSend" />
    <SetCompleteTicketModal :isVisible="setCompleteTicketModal" :ticketObj="selectedTicket"
      :requesterName="selectedRequesterName" :requesterEmail="selectedRequesterEmail"
      :requesterPhone="selectedRequesterPhone" :emailnotification="selectedTicketNotification" :allTypes='ticketTypes'
      :currentTicketTypeId="selectedTicketTypeId" :sourceTicketId="selectedTicketId"
      :lastActivity="selectedTicketLastActivity" :techs="clientTechs" :currentTech="selectedTech"
      @close="setCompleteTicketModal = false" @complete="handleCloseTicket" />
    <JobHistoryModal :isVisible="showHistoryModal" :history='jobHistory' :jobId="selectedHistoryJobId"
      @close="showHistoryModal = false" />
  </div>
</template>

<script>
import axios from 'axios';
import SendEmailModal from '@/views/modals/SendEmailModal.vue';
import JobHistoryModal from '@/views/modals/JobHistoryModal.vue';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';
import '@toast-ui/editor/dist/toastui-editor.css';
import '@toast-ui/editor/dist/theme/toastui-editor-dark.css';
import Viewer from '@toast-ui/editor/dist/toastui-editor-viewer';
import SetCompleteTicketModal from '@/views/modals/SetCompleteTicketModal.vue';
import moment from 'moment-timezone';
import { useToast } from "vue-toastification";
import { Editor } from '@toast-ui/editor';
import ThemeService from '@/services/ThemeService';
import BroadcastService from '@/services/BroadcastService';
import InternalBroadcastBanner from '@/views/components/InternalBroadcastBanner.vue';
export default {
  components: {
    SendEmailModal,
    SetCompleteTicketModal,
    JobHistoryModal,
    Viewer,
    InternalBroadcastBanner
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      startDate: '',
      endDate: '',
      jobs: [],
      jobTypes: [],
      isProgrammaticDateChange: false,
      viewers: {},
      editJob: {
        id: null,
        description: '',
        time: 0,
        ia: 0,
        publish: false,
        runningTime: 0,
        editor: null,
        timeInitially: 0,
        timeManuallyChanged: false
      },
      showEmailModal: false,
      selectedJobId: null,
      selectedRequesterName: '',
      selectedRequesterEmail: '',
      selectedRequesterPhone: '',
      activeJobIdForDocs: null,
      selectedFiles: [],
      selectedTicketLastActivity: '',
      selectedTicketId: null,
      selectedTicket: null,
      selectedTicketNotification: '',
      selectedTicketTypeId: 0,
      selectedTech: 0,
      clientTechs: [],
      setCompleteTicketModal: false,
      ticketTypes: [],
      runningTimes: {},
      timeSinceStarted: {},
      startTimes: {},
      jobTimer: null,
      ccEmails: [],
      savingJob: false,
      sidebarOpen: true,
      showHistoryModal: false,
      jobHistory: [],
      selectedHistoryJobId: null,
      selectedJobIdForAction: null,
      userId: localStorage.getItem('user_id'),
      userroles: [80],
      sortColumn: '',
      sortDirection: 'asc',
      actionItems: [],
      previousActionItems: [],
      showActionItemsDropdown: false,
      actionItemCount: 0,
      newActionItemCount: 0,
      activeBroadcasts: [],
      showBroadcastsDropdown: false,
      leaveToday: [],
      leaveFuture: [],
      hoveredLeaveIndex: null,
      hoveredLeaveType: '',
      showMiscShortcut: false,
      showTriageShortcut: false,
      showLunchShortcut: false,
      time: {},
      timestats: {},
      stats: [],
      hoveredTicketId: null,
      hoveredDescription: '',
      viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 1300,
      selectedTicketShortDescription: "",
    };
  },
  computed: {
    // Client broadcasts for the pill; internal ones show in InternalBroadcastBanner instead.
    clientBroadcasts() {
      return this.activeBroadcasts.filter(b => !b.internal);
    },
    isdark() {
      return ThemeService.isDark.value;
    },
    descLimit() {
      const w = this.viewportWidth;
      return w > 1700 ? 160 : (w > 1535 ? 140 : (w > 1300 ? 100 : (w > 1160 ? 80 : 60)));
    }
  },
  methods: {
    // Live broadcasts, shown to techs on the Jobs page above Action Items.
    async fetchActiveBroadcasts() {
      try {
        const { data } = await BroadcastService.getActive();
        this.activeBroadcasts = Array.isArray(data) ? data : (data.data || []);
      } catch (e) {
        // Non-fatal — the page works without the broadcast banner.
      }
    },
    async init() {
      this.$updateLoading(1);
      try {
        axios.get(`job/types`)
          .then(response => {
            this.jobTypes = response.data;
          })
          .catch(error => {
            console.error(error);
          });
        axios.get(`job/stats`)
          .then(response => {
            this.stats = response.data;
          })
          .catch(error => {
            console.error(error);
          });
        this.fetchActionItems();
        const [roleResponse] = await Promise.all([
          axios.get(`user/role/${this.userId}`),
          this.fetchJobs(),
        ]);
        this.userroles = Array.isArray(roleResponse.data?.roles) ? roleResponse.data.roles : [80];
      } catch (error) {
        console.error('Error fetching tickets:', error);
      } finally {
        this.$updateLoading(-1);
      }
    },
    goToAddJob() {
      this.$router.push('/job');
    },
    async handleFilterClick() {
      this.$updateLoading(1);
      await this.fetchJobs();
      this.$updateLoading(-1);
    },
    async fetchJobs() {
      this.selectedJobIdForAction = null;

      if (!this.userId) {
        return;
      }

      try {
        const response = await axios.post('job/userjobs', {
          userId: this.userId,
          startDate: this.startDate,
          endDate: this.endDate,
        });

        this.jobs = Array.isArray(response.data?.jobs) ? response.data.jobs : [];
        this.timestats = response.data?.stats || {};
        this.showMiscShortcut = response.data?.showMiscShortcut;
        this.showTriageShortcut = response.data?.showTriageShortcut;
        this.showLunchShortcut = response.data?.showLunchShortcut;

        if (this.jobTimer) {
          clearInterval(this.jobTimer);
          this.jobTimer = null;
        }
        this.runningTimes = {};
        this.timeSinceStarted = {};
        this.startTimes = {};
        this.time = {};
        this.jobs.forEach(job => {
          if (job.starttime !== '0000-00-00 00:00:00') {
            this.startJobTimer(job);
          }
        });
      } catch (error) {
        console.error('Error fetching jobs:', error);
      }
    },
    async fetchActionItems() {
      try {
        axios.get(`user/actionitems`)
          .then(response => {
            const data = response.data || {};
            this.leaveFuture = Array.isArray(data.leaveFuture) ? data.leaveFuture : [];
            this.leaveToday = Array.isArray(data.leaveToday) ? data.leaveToday : [];
            const tickets = Array.isArray(data.tickets) ? data.tickets : [];
            const myRequests = Array.isArray(data.myRequests) ? data.myRequests : [];
            const managerRequests = Array.isArray(data.managerRequests) ? data.managerRequests : [];
            const newItems = [
              ...tickets.map(t => ({ type: 'ticket', id: t.id })),
              ...myRequests.map(r => ({ type: 'myRequest', id: r.id })),
              ...managerRequests.map(r => ({ type: 'managerRequest', id: r.id }))
            ];

            const prev = this.previousActionItems;
            const prevKeySet = new Set(prev.map(i => `${i.type}-${i.id}`));

            const newOnes = newItems.filter(i => !prevKeySet.has(`${i.type}-${i.id}`));
            this.newActionItemCount = newOnes.length;

            this.actionItems = [
              ...data.tickets.map(t => ({ type: 'ticket', data: t, id: t.id })),
              ...data.myRequests.map(r => ({ type: 'myRequest', data: r, id: r.id })),
              ...data.managerRequests.map(r => ({ type: 'managerRequest', data: r, id: r.id }))
            ];
            this.previousActionItems = [...newItems];
            this.actionItemCount = this.actionItems.length;
          })
          .catch(error => {
            console.error(error);
          });
      } catch (err) {
        console.error("Failed to fetch action items", err);
      }
    },
    async addJobShortcut(type) {
      if (!['misc', 'triage', 'lunch'].includes(type)) return;

      this.$updateLoading(1);
      try {
        const response = await axios.post('job/shortcut', { shortcuttype: type });
        await this.fetchJobs();
        this.scrollToJob(response.data.id);
      } catch (err) {
        console.error(err);
        this.toast.error('Failed to create shortcut job.');
      } finally {
        this.$updateLoading(-1);
      }
    },
    acknowledgeTicket(id) {
      this.$updateLoading(1);
      axios.post('ticket/acknowledge', {
        ticketId: id,
        ack: 1
      })
        .then(response => {
          this.fetchActionItems();
        })
        .catch(error => {
          console.error('Error acknowledging ticket:', error);
        }).finally(() => {
          this.$updateLoading(-1);
        });
    },
    async handleWeekView() {
      if (!this.userId) return;

      this.$updateLoading(1);
      try {
        const response = await axios.post('job/userjobs', {
          userId: this.userId,
          currentWeek: 'true'
        });

        this.jobs = Array.isArray(response.data?.jobs) ? response.data.jobs : [];
        this.timestats = response.data?.stats || {};
        this.showMiscShortcut = response.data?.showMiscShortcut;
        this.showTriageShortcut = response.data?.showTriageShortcut;
        this.showLunchShortcut = response.data?.showLunchShortcut;
        if (this.jobTimer) {
          clearInterval(this.jobTimer);
          this.jobTimer = null;
        }
        this.runningTimes = {};
        this.timeSinceStarted = {};
        this.startTimes = {};
        this.time = {};
        this.jobs.forEach(job => {
          if (job.starttime != '0000-00-00 00:00:00') {
            this.startJobTimer(job);
          }
        });

        const phoenixNow = moment.tz("America/Phoenix");
        const startOfWeek = phoenixNow.clone().startOf('week'); // Sunday
        const endOfWeek = phoenixNow.clone().endOf('week');     // Saturday

        this.startDate = startOfWeek.format('YYYY-MM-DD');
        this.endDate = endOfWeek.format('YYYY-MM-DD');

      } catch (error) {
        console.error('Error loading week view jobs:', error);
      } finally {
        this.$updateLoading(-1);
      }
    },
    async startJob(job) {
      this.$updateLoading(1);
      try {
        await this.stopAllActiveJobs(job);
        this.fetchJobs()
      } finally {
        this.$updateLoading(-1);
      }
    },
    async startGivenJob(job) {
      this.$updateLoading(1);
      try {
        await axios.post('/job/start', {
          job_id: job.id
        });

        job.starttime = moment.tz("America/Phoenix").format("YYYY-MM-DD HH:mm:ss");
        job.lastedit = moment.tz("America/Phoenix").format("YYYY-MM-DD HH:mm:ss");
        this.startJobTimer(job);
        this.sortJobs();
        this.scrollListToTop();
      } catch (err) {
        console.error(err);
      } finally {
        this.$updateLoading(-1);
      }
    },
    async stopJob(job) {
      this.$updateLoading(1);
      try {
        const response = await axios.post('/job/stop', {
          job_id: job.id,
          description: job.description || '',
          ignorance_adjustment: job.ignoranceadjustment || 0,
          publish_to_portal: job.publish_to_portal ? 1 : 0,
          total_time: parseFloat(job.totaltime || 0)
        });

        this.stopJobTimer(job);
        job.starttime = '0000-00-00 00:00:00';
        job.lastedittime = moment.tz("America/Phoenix").format("YYYY-MM-DD HH:mm:ss");
        job.totaltime = parseFloat(response.data.totalTime).toFixed(2);
        if (this.editJob.id === job.id) {
          this.saveEditJob(job, false);
        } else {
          this.fetchJobs();
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.$updateLoading(-1);
      }
    },
    async stopAllActiveJobs(nextJob = null) {
      this.$updateLoading(1);
      try {
        const activeJobs = this.jobs.filter(j => j.starttime !== '0000-00-00 00:00:00');
        for (const j of activeJobs) {
          await this.stopJob(j);
        }
        if (nextJob) {
          await this.startGivenJob(nextJob);
        }
      } finally {
        this.$updateLoading(-1);
      }
    },
    async changeJobType(job) {
      if (job.jobtype_id === 10) {
        this.toast.error("Cannot change type 10.");
        return;
      }

      this.$updateLoading(1);
      try {
        const response = await axios.post(`/job/update-type/${job.id}`, {
          jobtype: job.jobtype_id
        });

        if (response.data.success === 1) {
          // Update background_class based on returned background color
          const colorMap = {
            gold: 'bg-yellow-400',
            pink: 'bg-pink-300',
            lightblue: 'bg-blue-300',
            lightgreen: 'bg-green-400',
            yellow: 'bg-yellow-300',
            E7E7E7: 'bg-gray-300',
            goldenrod: 'bg-yellow-500',
            violet: 'bg-violet-400',
            D3ACD4: 'bg-purple-300',
            ff4d4d: 'bg-red-200',
            '33A2FF': 'bg-blue-400',
          };

          const newBg = response.data.background;
          job.background_class = colorMap[newBg] || 'bg-gray-200';

          // this.toast.success("Job type updated!");
        } else {
          this.toast.error("Failed to update job type.");
        }
      } catch (error) {
        console.error("Error updating job type:", error);
        this.toast.error("Error updating job type.");
      } finally {
        this.$updateLoading(-1);
      }
    },
    async openJobHistory(job) {
      this.$updateLoading(1);
      try {
        const response = await axios.get(`/job/history/${job.id}`);
        this.jobHistory = response.data;
        this.selectedHistoryJobId = job.id;
        this.showHistoryModal = true;
      } catch (error) {
        console.error("Error fetching job history:", error);
        this.toast.error("Failed to load history.");
      } finally {
        this.$updateLoading(-1);
      }
    },
    handleResize() {
      this.viewportWidth = window.innerWidth;
    },
    truncate(str, n) {
      if (!str) return '';
      if (str.length <= n) return str;
      return str.slice(0, n).trimEnd() + '…';
    },
    scrollListToTop() {
      this.$nextTick(() => {
        const el = this.$refs.jobList;
        if (el && typeof el.scrollTo === 'function') {
          el.scrollTo({ top: 0, behavior: 'smooth' });
        } else if (el) {
          el.scrollTop = 0;
        }
      });
    },
    scrollToJob(jobId) {
      this.$nextTick(() => {
        const el = this.$refs['jobCard_' + jobId];
        if (el && el[0]) {
          el[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    setSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
      this.sortJobsByColumn();
    },
    sortJobsByColumn() {
      const direction = this.sortDirection === 'asc' ? 1 : -1;
      this.jobs.sort((a, b) => {
        let valA = a[this.sortColumn];
        let valB = b[this.sortColumn];

        if (this.sortColumn === 'client') {
          valA = a.client?.companyname || '';
          valB = b.client?.companyname || '';
        } else if (this.sortColumn === 'jobType') {
          valA = a.job_type?.name || '';
          valB = b.job_type?.name || '';
        } else if (this.sortColumn === 'description') {
          valA = a.description || '';
          valB = b.description || '';
        } else if (this.sortColumn === 'time') {
          valA = parseFloat(a.totaltime || 0);
          valB = parseFloat(b.totaltime || 0);
        }

        return valA > valB ? direction : valA < valB ? -direction : 0;
      });
    },
    sortJobs() {
      this.jobs.sort((a, b) => {
        // Convert to moment objects for comparison
        const startA = a.starttime;
        const startB = b.starttime;
        const editA = a.lastedittime;
        const editB = b.lastedittime;

        // Order by starttime DESC
        if (startA > startB) return -1;
        if (startA < startB) return 1;

        // Then order by lastedittime DESC
        if (editA > editB) return -1;
        if (editA < editB) return 1;

        return 0;
      });
    },
    async startQuickJob(ticketId) {
      // window.open(`https://atms.aimitservices.com/jobList.php?func=quick_add_job_from_ticket&ticket_id=${ticketId}`, '_blank');
      this.$updateLoading(1);
      axios.post('job/quickjob', { ticketId })
        .then(async response => {
          this.acknowledgeTicket(ticketId);
          await this.fetchJobs();
        })
        .catch(error => {
          console.error("Failed to create quick job:", error);
        })
        .finally(() => {
          this.$updateLoading(-1);
        });
    },
    gotoAddJob(ticketId) {
      this.acknowledgeTicket(ticketId);
      this.$router.push({ name: 'addEditJob', query: { ticketId: ticketId } });
    },
    startJobTimer(job) {
      const jobId = job.id;
      const startTimestamp = moment.tz(job.starttime, "America/Phoenix").valueOf();
      const now = moment.tz("America/Phoenix").valueOf();
      const alreadyTime = parseFloat(job.totaltime || 0);
      const diffHours = (now - startTimestamp) / (1000 * 60 * 60);
      this.timeSinceStarted[jobId] = diffHours;
      this.time.time1 = this.timestats.time1 + diffHours;
      this.time.time2 = this.timestats.time2 + diffHours;
      this.runningTimes[jobId] = diffHours + alreadyTime;
      this.startTimes[jobId] = startTimestamp;

      if (this.jobTimer) {
        clearInterval(this.jobTimer);
      }
      this.jobTimer = setInterval(() => {
        const nowNew = moment.tz("America/Phoenix").valueOf();
        const diff = (nowNew - this.startTimes[jobId]) / (1000 * 60 * 60);
        this.timeSinceStarted[jobId] = diff;
        this.runningTimes[jobId] = diff + alreadyTime;
        this.time.time1 = this.timestats.time1 + diffHours;
        this.time.time2 = this.timestats.time2 + diffHours;
        this.$forceUpdate();
      }, 30000);
    },
    stopJobTimer(job) {
      if (this.jobTimer) {
        clearInterval(this.jobTimer);
        this.jobTimer = null;
      }
      const jobId = job.id;
      if (this.runningTimes[jobId]) {
        job.totaltime = this.runningTimes[jobId].toFixed(2);
      }
      this.runningTimes[jobId] = 0;
      this.timeSinceStarted[jobId] = 0;
      this.startTimes[jobId] = null;
    },
    formatPhone(phone) {
      if (!phone) return '';

      const raw = String(phone).trim();
      let digits = raw.replace(/\D/g, '');

      if (digits.length === 11 && digits.startsWith('1')) {
        digits = digits.slice(1);
      }
      if (digits.length === 10) {
        const area = digits.slice(0, 3);
        const prefix = digits.slice(3, 6);
        const line = digits.slice(6);
        return `(${area}) ${prefix}-${line}`;
      }
      return raw;
    },
    hasRequesterEmail(job) {
      return (
        (job.contact && job.contact.email) || (job.ticket && job.ticket.email) ||
        (job.ticket && job.ticket.contact && job.ticket.contact.email)
      );
    },
    getRequesterName(job) {
      if (job.contact) {
        return job.contact.name;
      } else if (job.ticket && job.ticket.requester) {
        return job.ticket.requester;
      } else if (job.ticket && job.ticket.contact && job.ticket.contact.name) {
        return job.ticket.contact.name;
      }
      return '';
    },
    // All of a requester's phone numbers (primary + secondary), falling back to the
    // ticket's alternate phone when the contact has none.
    getRequesterPhones(job) {
      const contact = job.contact ? job.contact : (job.ticket?.contact);
      const phones = [];

      if (contact) {
        if (contact.phone_primary) {
          phones.push({ number: contact.phone_primary, label: 'Primary', ext: contact.phone_primary_ext || '' });
        }
        if (contact.phone_secondary) {
          phones.push({ number: contact.phone_secondary, label: 'Secondary', ext: contact.phone_secondary_ext || '' });
        }
      }

      if (!phones.length && job.ticket?.alternatephone) {
        phones.push({ number: job.ticket.alternatephone, label: 'Alternate', ext: '' });
      }

      return phones;
    },
    getRequesterPhone(job) {
      return this.getRequesterPhones(job)[0] || { number: '', label: '', ext: '' };
    },
    getRequesterEmail(job) {
      if (job.contact) {
        return job.contact.email;
      } else if (job.ticket && job.ticket.email) {
        return job.ticket.email;
      } else if (job.ticket && job.ticket.contact && job.ticket.contact.email) {
        return job.ticket.contact.email;
      }
      return '';
    },
    initViewer(jobId, content) {
      const viewerContainerId = `viewer-${jobId}`;
      const container = document.getElementById(viewerContainerId);

      if (!container) {
        console.warn('Viewer container not found:', viewerContainerId);
        return;
      }

      if (this.viewers[jobId]) {
        this.viewers[jobId].destroy();
        delete this.viewers[jobId];
      }

      container.innerHTML = '';

      const newEl = document.createElement('div');
      newEl.id = viewerContainerId;
      container.parentNode.replaceChild(newEl, container);

      this.$nextTick(() => {
        const el = document.getElementById(viewerContainerId);
        this.viewers[jobId] = new Viewer({
          el,
          initialValue: this.fixMarkdownIndentation(content || ''),
          theme: this.isdark ? 'dark' : 'default',
        });
      });
    },
    fixMarkdownIndentation(text) {
      return text
        .split('\n')
        .map(line => {
          // Fix indentation for list items that start with ' - '
          if (line.startsWith(' - ')) {
            line = '    - ' + line.slice(3);
          }

          // Fix markdown headings without space, e.g., '###Heading' → '### Heading'
          line = line.replace(/^(#{1,6})([^\s#])/g, '$1 $2');

          return line;
        })
        .join('\n');
    },
    async toggleEditJob(job) {
      if (this.editJob.id === job.id) {
        await this.saveEditJob(job, true);
        this.editJob.id = null;
        return;
      }

      if (this.editJob.id) {
        const prevJob = this.jobs.find(j => j.id === this.editJob.id);
        if (prevJob) {
          await this.saveEditJob(prevJob, true);
        }
      }

      this.editJob.id = job.id;
      this.editJob.description = this.fixMarkdownIndentation(job.description || '');
      const base = parseFloat(job.totaltime || 0);
      this.editJob.time = base.toFixed(2);
      this.editJob.timeInitially = base;
      this.editJob.timeManuallyChanged = false;
      this.editJob.ia = parseFloat(job.ignoranceadjustment || 0).toFixed(2);
      this.editJob.publish = !!job.publish_to_portal;
      this.scrollToJob(job.id);
    },
    onEditorTransitionEnter(job) {
      this.initEditor(job.id);
    },
    destroyEditor() {
      if (this.editJob.editor) {
        try {
          this.editJob.editor.destroy();
        } catch (e) {
          // editor may already be partially torn down; nothing to do.
        }
        this.editJob.editor = null;
      }
    },
    initEditor(jobId) {
      this.destroyEditor();
      let editorContainer = this.$refs['editor_' + jobId];
      if (Array.isArray(editorContainer)) {
        editorContainer = editorContainer[0];
      }

      if (editorContainer) {
        const editor = new Editor({
          el: editorContainer,
          initialValue: this.editJob.description,
          height: '500px',
          previewStyle: 'vertical',
          initialEditType: 'markdown',
          usageStatistics: false,
          theme: this.isdark ? 'dark' : 'default',
          toolbarItems: [
            ['heading', 'bold', 'italic', 'strike'],
            ['hr', 'quote'],
            ['ul', 'ol', 'task', 'indent', 'outdent'],
            ['table', 'link'],
            ['code', 'codeblock'],
            ['scrollSync'],
          ],
          hooks: {
            addImageBlobHook: () => false
          }
        });
        this.editJob.editor = editor;
      } else {
        console.error(`Editor container still not found for job ${jobId}`);
      }
    },
    async saveEditJob(job, close = false) {
      this.savingJob = true;
      await this.fetchJobs();
      const updated = this.jobs.find(j => j.id == job.id);
      try {
        if (
          this.editJob.timeManuallyChanged === false &&
          updated &&
          updated.totaltime != null &&
          this.editJob.timeInitially != updated.totaltime) {
          this.editJob.time = parseFloat(updated.totaltime).toFixed(2);
          this.editJob.timeInitially = parseFloat(updated.totaltime || 0)
        }
        job.description = this.editJob.editor.getMarkdown();
        const response = await axios.post(`/job/notes/${job.id}`, {
          description: job.description,
          ia: parseFloat(this.editJob.ia),
          total: parseFloat(this.editJob.time),
          publish: this.editJob.publish ? 1 : 0,
          client_id: job.company_id || 0,
          ticket_id: job.ticket_id || 0,
        });
        this.fetchJobs();
        if (close) {
          this.destroyEditor();
          this.editJob.id = null;
        }
        // this.toast.success('Job saved successfully!!');
      } catch (err) {
        console.error('Error saving job edit:', err);
        this.toast.error('Error saving job!!');
      } finally {
        this.savingJob = false;
      }
    },
    cancelEditJob() {
      this.destroyEditor();
      this.editJob.id = null;
    },
    goToViewTicket(id) {
      const { href } = this.$router.resolve({
        name: 'ticketDetails',
        params: { ticketId: id }
      });
      window.open(href, '_blank', 'noopener,noreferrer');
    },
    openEmailModal(job) {
      this.selectedJobId = job.id;
      this.selectedRequesterName = this.getRequesterName(job);
      this.selectedRequesterEmail = this.getRequesterEmail(job);
      const rawDesc = job.ticket ? job.ticket.description : "";
      const cleanedDesc = rawDesc
        .replace(/[\r\n]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

      this.selectedTicketShortDescription = cleanedDesc;
      let ccList = [];
      if (job.ticket && job.ticket.watcher && Array.isArray(job.ticket.watcher)) {
        ccList = job.ticket.watcher
          .map(w => w.contact?.email)
          .filter(email => !!email);
      }

      this.ccEmails = ccList;
      this.showEmailModal = true;
    },
    async handleEmailSend(payload) {
      this.$updateLoading(1);
      try {
        await axios.post('job/send-email', {
          job_id: payload.jobId ? payload.jobId : 0,
          ticket_id: payload.ticketId ? payload.ticketId : 0,
          subject: payload.subject,
          to: payload.to,
          cc: payload.cc,
          body: payload.body,
        });
        this.showEmailModal = false;
        this.toast.success("Email sent successfully!");
        await this.fetchJobs();
      } catch (err) {
        console.error("Error sending email:", err);
        this.toast.error("Failed to send email.");
      } finally {
        this.$updateLoading(-1);
      }
    },
    onInput(field, event) {
      const val = parseFloat(event.target.value);
      this.editJob[field] = isNaN(val) ? 0 : val;
    },
    adjustTime(field, delta) {
      let val = parseFloat(this.editJob[field]) || 0;
      val += delta;
      this.editJob[field] = Math.max(0, Math.round(val * 100) / 100);
      if (field == 'time') {
        this.editJob.timeManuallyChanged = true;
      }
    },
    onDropZoneDragOver(e) {
      // You can style hover if you want; already preventing default in template
    },

    async handleDrop(e, job) {
      const files = [];
      if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
        for (const f of e.dataTransfer.files) {
          // Accept only meaningful files (mostly images but you can allow all)
          files.push(f);
        }
      }
      if (files.length) {
        this.pushSelectedFiles(files);
      }
    },

    async handlePaste(e, job) {
      const dt = e.clipboardData || window.clipboardData;
      if (!dt) return;

      const files = [];

      // 1) Direct image items from clipboard
      for (let i = 0; i < dt.items.length; i++) {
        const item = dt.items[i];
        if (item.kind === 'file' && item.type && item.type.startsWith('image/')) {
          const file = item.getAsFile();
          if (file) {
            // Ensure a nice filename
            const ext = file.type.split('/')[1] || 'png';
            const named = new File([file], `pasted-${Date.now()}.${ext}`, { type: file.type });
            files.push(named);
          }
        }
      }

      // 2) Fallback: HTML may contain <img src="data:image/...;base64,....">
      if (!files.length) {
        const html = dt.getData('text/html');
        if (html) {
          const dataUrls = this.extractDataImageSrcs(html);
          for (const { mime, data } of dataUrls) {
            const blob = this.base64ToBlob(data, mime);
            const ext = mime.split('/')[1] || 'png';
            const named = new File([blob], `pasted-${Date.now()}.${ext}`, { type: mime });
            files.push(named);
          }
        }
      }

      // 3) Fallback: plain text might be a data URL
      if (!files.length) {
        const txt = dt.getData('text/plain') || '';
        if (txt.startsWith('data:image/')) {
          const match = txt.match(/^data:(image\/[a-zA-Z0-9.+-]+);base64,(.*)$/);
          if (match) {
            const mime = match[1];
            const data = match[2];
            const blob = this.base64ToBlob(data, mime);
            const ext = mime.split('/')[1] || 'png';
            const named = new File([blob], `pasted-${Date.now()}.${ext}`, { type: mime });
            files.push(named);
          }
        }
      }

      if (files.length) {
        this.pushSelectedFiles(files);
      }
    },

    pushSelectedFiles(files) {
      // Make sure panel is visible
      if (!this.activeJobIdForDocs) return;
      // Accumulate across picks/pastes/drops, de-duping by name+size.
      const merged = [...this.selectedFiles];
      files.forEach(f => {
        if (!merged.some(e => e.name === f.name && e.size === f.size)) {
          merged.push(f);
        }
      });
      this.selectedFiles = merged;
    },
    removeSelectedFile(index) {
      this.selectedFiles.splice(index, 1);
    },

    extractDataImageSrcs(html) {
      const out = [];
      const div = document.createElement('div');
      div.innerHTML = html;
      const imgs = div.querySelectorAll('img');
      imgs.forEach(img => {
        const src = img.getAttribute('src') || '';
        const m = src.match(/^data:(image\/[a-zA-Z0-9.+-]+);base64,(.*)$/);
        if (m) {
          out.push({ mime: m[1], data: m[2] });
        }
      });
      return out;
    },

    base64ToBlob(b64, mime) {
      const byteChars = atob(b64);
      const byteNumbers = new Array(byteChars.length);
      for (let i = 0; i < byteChars.length; i++) {
        byteNumbers[i] = byteChars.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      return new Blob([byteArray], { type: mime });
    },

    // tweak: after opening, focus the dropzone so Ctrl+V works immediately
    triggerFileInput(job) {
      // Keep any already-selected/pasted/dropped files; just open the picker
      // so the user can add more on top of the current selection.
      this.scrollToJob(job.id);

      this.$nextTick(() => {
        const fileInputRef = this.$refs['fileInput_' + job.id];
        const el = Array.isArray(fileInputRef) ? fileInputRef[0] : fileInputRef;
        // Focus paste/drop zone for immediate paste
        const dz = this.$refs.pasteDropZone;
        if (dz && dz.focus) dz.focus();

        if (el && typeof el.click === 'function') {
          el.click();
        }
      });
    },
    triggerdoc(job) {
      // Clear pending files only when switching to a different job's panel,
      // so reopening the picker for the same job keeps adding to the list.
      if (this.activeJobIdForDocs !== job.id) {
        this.selectedFiles = [];
      }
      this.activeJobIdForDocs = job.id;
    },
    handleFilesSelected(job) {
      const fileInputRef = this.$refs['fileInput_' + job.id];
      const el = Array.isArray(fileInputRef) ? fileInputRef[0] : fileInputRef;

      if (el && el.files && el.files.length > 0) {
        this.pushSelectedFiles(Array.from(el.files));
        // Reset so re-picking the same file fires change again ("add more").
        el.value = '';
      }
    },
    async uploadFiles(job) {
      this.$updateLoading(1); // Start loading indicator

      const formData = new FormData();
      this.selectedFiles.forEach(file => {
        formData.append('docs[]', file);
      });

      // Add company_id and contact_id from job.ticket
      formData.append('company_id', job.ticket.company_id || 0);
      formData.append('contact_id', job.ticket.contact_id || 0);
      try {
        await axios.post(`documents/${job.ticket.id}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        this.activeJobIdForDocs = null;
        this.selectedFiles = [];
        await this.fetchJobs();
      } catch (err) {
        console.error("Error uploading docs:", err);
        this.toast.error("Error uploading docs");
      } finally {
        this.$updateLoading(-1);
      }
    },
    cancelFiles() {
      this.activeJobIdForDocs = null;
      this.selectedFiles = [];
    },
    async openSetCompleteTicketModal(job, ticket) {
      this.selectedTicketLastActivity = job.ts;
      this.selectedTicketId = ticket.id;
      this.selectedTicketTypeId = ticket.ticket_type.id;
      // Unassigned tickets (tech_id 0) have no user_profile — fall back to the raw
      // tech_id so closing one doesn't throw.
      this.selectedTech = ticket.user_profile?.id ?? ticket.tech_id;
      this.selectedTicketNotification = ticket.emailnotification;
      this.selectedRequesterName = this.getRequesterName(job);
      this.selectedRequesterEmail = this.getRequesterEmail(job);
      this.selectedRequesterPhone = this.getRequesterPhone(job).number || '';
      this.selectedTicket = ticket;
      try {
        this.$updateLoading(1);
        const response = await axios.get(`${axios.defaults.baseURL}user/active/transfer/${ticket.company_id}`);
        const typesresponse = await axios.get(`ticket/get-types/${ticket.company_id}`);
        this.ticketTypes = typesresponse.data;
        this.clientTechs = response.data;

        this.setCompleteTicketModal = true;
      } catch (error) {
        console.error("Error fetching active users for the client:", error);
      } finally {
        this.$updateLoading(-1);
      }
    },
    async handleCloseTicket({ ticketId, techId, day, sendEmail, closingNote, ticketTypeId, aiEdited, notifyCompany }) {
      this.$updateLoading(1);
      if (this.editJob?.id) {
        const currentJob = this.jobs.find(j => j.id === this.editJob.id);
        const currentTicketId = currentJob?.ticket?.id ?? currentJob?.ticket_id ?? null;

        if (currentJob && currentTicketId && currentTicketId == ticketId) {
          await this.saveEditJob(currentJob, true);
        }
      }
      try {
        await axios.post('ticket/close', {
          ticketId,
          techId,
          day,
          sendEmail,
          closingNote,
          ticketTypeId,
          aiEdited,
          notifyCompany
        });
        await this.fetchJobs();
      } catch (error) {
        console.error('Error closing ticket:', error);
        this.toast?.error?.("Failed to close ticket.");
      } finally {
        this.$updateLoading(-1);
      }
    },
    handleEditJob() {
      if (!this.selectedJobIdForAction) {
        this.toast.error("Please select a job to edit.");
        return;
      }

      this.$router.push({ name: 'addEditJob', params: { jobId: this.selectedJobIdForAction } });
    },
    async handleDeleteJob() {
      if (!this.selectedJobIdForAction) {
        this.toast.error("Please select a job to delete.");
        return;
      }

      if (!confirm("Are you sure you want to delete this job?")) {
        return;
      }

      this.$updateLoading(1);
      try {
        await axios.post(`job/delete/${this.selectedJobIdForAction}`);
        this.toast.success("Job deleted successfully.");
        await this.fetchJobs();
        this.selectedJobIdForAction = null;
      } catch (err) {
        console.error(err);
        this.toast.error("Failed to delete job.");
      } finally {
        this.$updateLoading(-1);
      }
    }
  },
  watch: {
    startDate(newVal) {
      if (this.dp) {
        if (this.isProgrammaticDateChange) {
          this.isProgrammaticDateChange = false;
          return;
        }

        this.isProgrammaticDateChange = true;
        const selDate = new Date(newVal + 'T00:00:00');
        this.dp.setDate(selDate);
      }
    },
    jobs(newJobs) {
      this.$nextTick(() => {
        newJobs.forEach(job => {
          this.initViewer(job.id, job.description);
        });
      });
    },
    isdark(newVal) {
      console.log('heyyyyyy (dark mode change detected): ', this.isdark);
      this.$nextTick(() => {
        this.jobs.forEach(job => {
          this.initViewer(job.id, job.description);
        });
      });

      // Re-init editor if editing
      if (this.editJob.id && this.editJob.editor) {
        this.editJob.description = this.editJob.editor.getMarkdown();
        const jobId = this.editJob.id;
        this.editJob.editor.destroy();
        this.editJob.editor = null;

        this.$nextTick(() => {
          this.initEditor(jobId);
        });
      }
    }
  },
  beforeUnmount() {
    Object.values(this.viewers).forEach(viewer => {
      if (viewer) viewer.destroy();
    });
    this.destroyEditor();
    clearInterval(this.jobListInterval);
    clearInterval(this.actionItemsInterval);
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    const phoenixNow = moment.tz("America/Phoenix");
    const dateObj = phoenixNow.toDate(); // Native Date object

    // Set initial start and end dates in Phoenix time
    const todayStr = phoenixNow.format('YYYY-MM-DD');
    this.startDate = todayStr;
    this.endDate = todayStr;

    // Initialize datepicker using Phoenix date
    this.dp = new window.Datepicker(document.getElementById("datepicker-inline"), {
      autohide: true,
      todayHighlight: true,
      defaultViewDate: dateObj,
      startDate: dateObj
    });

    // Set calendar date
    this.dp.setDate(dateObj);

    // Listen to calendar date change
    document.getElementById("datepicker-inline").addEventListener('changeDate', (e) => {
      const selected = e.detail.date;
      const selDate = moment.tz(selected, "America/Phoenix").format('YYYY-MM-DD');
      // Set start and end dates to this date
      this.isProgrammaticDateChange = true;
      this.startDate = selDate;
      this.endDate = selDate;
      this.$updateLoading(1);
      this.fetchJobs().finally(() => {
        this.$updateLoading(-1);
      });
    });
    window.addEventListener('resize', this.handleResize, { passive: true });
    this.init();
    this.fetchActiveBroadcasts();
    this.actionItemsInterval = setInterval(() => {
      this.fetchActionItems();
      this.fetchActiveBroadcasts();
    }, 60000);
    this.jobListInterval = setInterval(() => {
      this.fetchJobs();
    }, 60000);
  }
}
</script>

<style>
#datepicker-inline {
  transform: scale(0.73);
  transform-origin: top left;
  width: 320px;
  /* keep original widget width before scaling */
  margin: 0 !important;
  padding: 0 !important;
}

/* inline calendar wrapper */
#datepicker-inline .datepicker,
#datepicker-inline .datepicker-picker {
  background: #ffffff !important;
  border: none !important;
  border-radius: 12px !important;
  overflow: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* inner sections */
#datepicker-inline .datepicker-view,
#datepicker-inline .days,
#datepicker-inline .days-of-week,
#datepicker-inline .datepicker-grid,
#datepicker-inline .datepicker-main,
#datepicker-inline .datepicker-header {
  background: #ffffff !important;
}

/* top controls */
#datepicker-inline .datepicker-controls {
  background: #ffffff !important;
  padding: 8px 10px !important;
  border: none !important;
}

#datepicker-inline .datepicker-controls .button,
#datepicker-inline .datepicker-controls button {
  background: transparent !important;
  border: none !important;
  color: #111827 !important;
  box-shadow: none !important;
  font-weight: 600 !important;
}

#datepicker-inline .view-switch {
  font-weight: 700 !important;
  color: #111827 !important;
}

/* days of week */
#datepicker-inline .dow {
  color: #6b7280 !important;
  font-size: 11px !important;
  font-weight: 500 !important;
}

/* all date cells */
#datepicker-inline .datepicker-cell {
  color: #111827 !important;
  background: transparent !important;
  border-radius: 8px !important;
}

#datepicker-inline .datepicker-cell:hover {
  background: #f3f4f6 !important;
}

#datepicker-inline .datepicker-cell.selected,
#datepicker-inline .datepicker-cell.active {
  background: #2563eb !important;
  color: #ffffff !important;
}

#datepicker-inline .datepicker-cell.today:not(.selected):not(.active) {
  background: #eff6ff !important;
  color: #1d4ed8 !important;
  border-radius: 8px !important;
}

#datepicker-inline .datepicker-cell.disabled {
  color: #9ca3af !important;
}

/* DARK MODE */
.dark #datepicker-inline .datepicker,
.dark #datepicker-inline .datepicker-picker,
.dark #datepicker-inline .datepicker-view,
.dark #datepicker-inline .days,
.dark #datepicker-inline .days-of-week,
.dark #datepicker-inline .datepicker-grid,
.dark #datepicker-inline .datepicker-main,
.dark #datepicker-inline .datepicker-header,
.dark #datepicker-inline .datepicker-controls {
  background: #111827 !important;
  border: none !important;
}

.dark #datepicker-inline .datepicker,
.dark #datepicker-inline .datepicker-picker {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35) !important;
}

.dark #datepicker-inline .datepicker-controls .button,
.dark #datepicker-inline .datepicker-controls button,
.dark #datepicker-inline .view-switch {
  color: #f9fafb !important;
  background: transparent !important;
  border: none !important;
}

.dark #datepicker-inline .dow {
  color: #9ca3af !important;
}

.dark #datepicker-inline .datepicker-cell {
  color: #f9fafb !important;
  background: transparent !important;
}

.dark #datepicker-inline .datepicker-cell:hover {
  background: #374151 !important;
}

.dark #datepicker-inline .datepicker-cell.selected,
.dark #datepicker-inline .datepicker-cell.active {
  background: #2563eb !important;
  color: #ffffff !important;
}

.dark #datepicker-inline .datepicker-cell.today:not(.selected):not(.active) {
  background: #1f2937 !important;
  color: #93c5fd !important;
}

.dark #datepicker-inline .datepicker-cell.disabled {
  color: #6b7280 !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.sidebar-slide-enter-active,
.sidebar-slide-leave-active {
  transition: all 0.3s ease;
}

.sidebar-slide-enter-from,
.sidebar-slide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

.sidebar-slide-enter-to,
.sidebar-slide-leave-from {
  transform: translateX(0);
  opacity: 1;
}

/* .toastui-editor-defaultUI {
  background-color: white;
} */
</style>
